// import { IntentDispatcher } from "@jet/environment/dispatching";
import type { Localizer } from '@jet/environment/localization';
import { Router } from '@jet/environment/routing';
import { makeMetatype } from '@jet/environment/util/metatype';

// import type { fetchFlowPage } from "../routing/routing";

// import { AnonymousNetworkDependency } from "./anonymous-network";
// import { Bag } from "./bag";
// import { Client } from "./client";
// import { Duration } from "./duration";
// import { LegacyLocalizer } from "./legacy-localizer";
// import { Locale } from "./locale";
// import { Logger } from "./logger";
// import { NetworkDependency } from "./network";
// import { Properties } from "./properties";
// import { Random } from "./random";
// import { Seo } from "./seo";
// import { User } from "./user";

// BAILEY
/** Dependency metatypes used in the object graph. */
export const DependencyType = Object.freeze({
    // ANONYMOUS_NETWORK: makeMetatype<AnonymousNetworkDependency>("anonymousNetwork"),
    // BAG: makeMetatype<Bag>("bag"),
    // CLIENT: makeMetatype<Client>("client"),
    // DURATION: makeMetatype<Duration>("duration"),
    // FETCH_FLOWPAGE: makeMetatype<typeof fetchFlowPage>("fetchFlowPage"),
    // INTENT_DISPATCHER: makeMetatype<IntentDispatcher>("intentDispatcher"),
    // LEGACY_LOCALIZER: makeMetatype<LegacyLocalizer>("legacyLocalizer"),
    // LOCALE: makeMetatype<Locale>("locale"),
    LOCALIZER: makeMetatype<Localizer>('localizer'),
    // LOGGER: makeMetatype<Logger>("logger"),
    // NETWORK: makeMetatype<NetworkDependency>("network"),
    // PROPERTIES: makeMetatype<Properties>("properties"),
    // RANDOM: makeMetatype<Random>("random"),
    ROUTER: makeMetatype<Router>('router'),
    // SEO: makeMetatype<Seo>("seo"),
    // USER: makeMetatype<User>("user"),
});
